import $api from "../../../../services/axiosService";
import RequestServices from "../../../../../frontend.services/RequestServices/RequestServices";
import { setCurrentHrDocsAction } from "../setCurrenrRequest.action";

export const setCurrentHrDocsThunkAction = (entityId, workerId, typeViewTo, entityType, props) => async (dispatch) => {
    try {
        const response = await $api(`v2/directum/documents/${entityId}/${workerId}`, { params: { entityType } });
        if (response.status === 200) {
            const dataDocuments = await RequestServices.getOneHrDocument(response.data, typeViewTo, workerId, props);
            dispatch(setCurrentHrDocsAction(dataDocuments));
        }
    } catch (e) {
        if (props) {
            props.closeHandlerPackages && props.closeHandlerPackages();
            props.setErrDescription &&  props.setErrDescription(e.response && e.response.data && e.response.data.detail ? `${e.response.data.detail}, \n повторите попытку позже! ` : "Что-то пошло не так, повторите попытку позже!");
            props.helper && props.helper(true);
        }
    }
};

